import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';
import { connect } from 'react-redux';
import {  uploadPreview, checkUploadType, getHtml2Text } from '../../../../utils/constants';
import moment from 'moment';
import * as url from '../../../../utils/url';
import {  Dropdown, DropdownItem, DropdownToggle, DropdownMenu,Card, CardBody, CardImg, CardTitle, CardText, Input, Row, Col } from "reactstrap";
import CKEditorUI from '../../../../components/CKEditor/CKEditorUI';
import Title from './ReportTitle';
import ReportUploads from './ReportUploads';
import Section from './SingleReportSectionItem';
import AddContent from '../../../../assets/placeholders/report_content.svg';

let placeholderTxt = 'What is your insight about this chart?'

class SingleReport extends Component {

  // ChildElement = React.createRef();


  constructor(props) {
    super(props);
    this.state = { 
        singleNote: this.props.selectedInsight? {...this.props.selectedInsight}:{},
        actionType: this.props.actionType,
        openCreateChartReport:this.props.openCreateChartReport,
        description: this.props.selectedInsight? this.props.selectedInsight.description:'',
        updatedFields:[],
        setImagesPreview:[],
        rejectedFiles:[],
        sections:[],
        high_count:[],
        dropdownOpenPeriod:false
     }
    //  returnName
    this.childRef = React.createRef();
  
  }
  
  componentDidMount(){
    // this.getAttachedItems()
    // console.log(this.childNode1)
  }

  
  
  componentDidUpdate(prevProps) {
   let{openCreateChartReport}=this.props
  //  if(prevProps.openCreateChartReport != openCreateChartReport){
  //    let obj={openCreateChartReport}
  //    if(this.props.selectedInsight && Object.keys(this.props.selectedInsight).length>0){
  //      let{selectedInsight}=this.props
  //       obj={...obj, singleNote:{...selectedInsight}}
  //    }
  //    this.setState({...obj})
  //   }
    // (prevProps.openCreateChartReport == openCreateChartReport )&& 
  
    // if( prevProps.actionType!=this.props.actionType ) {
    //  if(this.props.actionType=='CREATE'){
    //       this.setState({
    //         actionType:'CREATE',
    //         singleNote: null,
    //         description:''
    //       })
    //   } else{
    //     this.setState({actionType:this.props.actionType})
    //   }
     
    // }
  }




handleChangeText = (event) => {
    let descriptionContext = event.editor.getData();
    let{singleNote}=this.state
    singleNote = {...singleNote, description:descriptionContext }
    this.setState({ singleNote, description:descriptionContext })
} 

handleChangeInsightTitle = (event) => {
  const { value } = event.target;
  let { singleNote } = this.state
  let result = {...singleNote, name:value }
  this.setState({ singleNote:result })
}

handleClick = event => {
  const { target = {} } = event || {};
  target.value = "";
};

submitChartInsight= (insight_name) =>{
  let{setImagesPreview, singleNote, actionType}=this.state
  let that=this
  let isDesc = singleNote.description &&  singleNote.description != undefined  &&  singleNote.description != null ? singleNote.description.replace(/<\/?[^>]+(>|$)/g, "") : '';
  const formData = new FormData();

  if(isDesc.length>0){
    let{description}=singleNote
    if(setImagesPreview && setImagesPreview.length>0){
      Array.from(setImagesPreview).forEach(itm => {
        delete itm.isAccepted
        formData.append('uploads', itm.file);
      })
    }  

    let sanitizedDesc = getHtml2Text(description)
    formData.append('chartId', this.props.chart._id)
    formData.append('chart_name', this.props.chart.name)
    formData.append('userId', this.props.user.profile._id)
    formData.append('dashboardId', this.props.reports._id)
    formData.append('orgId', this.props.user.profile.organizationId._id)
    formData.append('timestamp', new Date())
    formData.append('description',description)
    formData.append('sanitizedDesc',sanitizedDesc)
    formData.append('firstname', this.props.user.profile.firstName)
    formData.append('lastname', this.props.user.profile.lastName)

    let name=insight_name && insight_name.length>0?insight_name:''
    
    if(name){
      formData.append('name',name)
    }



  if(actionType!='EDIT'){
      axios.post(url.createChartInsight, formData, { headers: {
        'Content-Type': 'multipart/form-data'
      }}).then(({ data }) => {
        that.props.updateReportCharts(data.data)
        that.props.closeAddInsight(data.data.insights)
      })
  } else {
    const editformData = new FormData();
    
    if(name){
      editformData.append('name',name)
    }
    editformData.append('description',description)
    editformData.append('sanitizedDesc',sanitizedDesc)
    editformData.append('updated', new Date())
    editformData.append('insightId', singleNote._id)
    editformData.append('chartId', this.props.chart._id)
    editformData.append('chart_name', this.props.chart.name)
    editformData.append('userId', this.props.user.profile._id)
    editformData.append('dashboardId', this.props.reports._id)
    editformData.append('firstname', this.props.user.profile.firstName)
    editformData.append('lastname', this.props.user.profile.lastName)
    editformData.append('timestamp', singleNote.timestamp)

    

    axios.post(url.editChartInsight, editformData, { headers: {
      'Content-Type': 'multipart/form-data'
    }}).then(({ data }) => {
      that.props.updateReportCharts(data.data)
      that.props.closeAddInsight(data.data.insights)
    })
  }



  }

}

openCreateChartReport=()=>{
  this.props.closeSingleInsight()
  // this.setState( prevState =>({ openCreateChartReport: !prevState.openCreateChartReport }))
}

createMarkup(html){
  return { __html: `<div>${html}</div>` };
}


changeInsightAction=(val)=>{
  if(val=='CREATE'){
    this.setState({
      singleNote:{},
      actionType:'CREATE',
      description:''
    })
  }
  this.props.changeInsightAction(val)
}

renderViewOnly=()=>{
  let{singleNote}=this.state
  if(singleNote && singleNote.description){
    return (
      <span className="singleInsightViewContainer">
        
        
        <span className="singleReportDashboardContainerOptions">
        <span className="singleReportViewContainerBtn btn-info">View <i className='flaticon-vision'/> </span>

          <span className="singleReportViewContainerBtn btn-outline-success"
          onClick={()=>this.changeInsightAction('EDIT')}> Update <i className='flaticon-edit'/> </span>

           <span className="singleReportViewContainerBtn btn-outline-primary"
          onClick={()=>this.changeInsightAction('CREATE')}> Add Report 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
          </span>  

          <span className="singleReportViewContainerBtn btn-outline-secondary"
          onClick={()=>this.openCreateChartReport()}> All Reports <i className='flaticon-paper'/> </span>
        </span>
       


      <span className="singleInsightViewMainContent">
        <div className="singleInsightViewContentContainer">
            <Title actionType={"VIEW"} 
            singleNote ={singleNote}
            // name = {this.state.singleNote && this.state.singleNote.name?this.state.singleNote.name:''}
            />
            <div>
                <span className="singleInsightViewDetails text-muted">
                {singleNote.firstname} {singleNote.lastname} on {moment(singleNote.timestamp).format("MMM D, YYYY")}
                </span>

            </div>
        </div>

        <div dangerouslySetInnerHTML={this.createMarkup(singleNote.description)} className="singleInsightViewDescription"  />                  
    
      </span>
      </span>
    )
  }
}


addReportResource=(type,sec_no)=>{
  let{sections}=this.state 
  if(type=='content'){
    let section_idx = sections.indexOf(parseInt(sec_no)) 
    let curr_section = sections.slice(section_idx)
    let grp_count = (curr_section.filter(e=> parseInt(e) == parseInt(sec_no))).sort()
    let last_count = grp_count[grp_count.length-1]
    let next_count = last_count + 0.01
    let idx = sections.indexOf(sec_no) +1
    // sec_no = sec_no+.01
    sections.splice(idx,0,next_count)
    console.log('sections: ', sections)
  }

  if(type=='section'){
    let slength = sections.length+1
    sections= [...sections, slength]
    console.log('slength: ',slength)
  }

  this.setState({sections})
}

removeSection=(idx)=>{
  console.log('idx: ', idx)
  if(idx % 1 == 0){
    let sect_no = parseInt(idx), {sections}=this.state
    let new_sections = sections.filter(e=> e<sect_no || e>= (sect_no+1) )
    this.setState({sections:new_sections})
  } else { 
    this.setState(prevState=>({
      sections: prevState.sections.filter(e=>e!=idx)
    }))
  }
}


renderSections=()=>{
  let{sections, }=this.state
  if(sections && sections.length>0){
    return(<div className="singleReportSectionsContainer">
      {sections.map(e=>{
        return (
          <span key={e}>
        <Section 
          id={e}
          isSection={true}
          isContext={e % 1 != 0}
          removeSection={this.removeSection}/>
          <ReportUploads 
          id={e}/>
          {e % 1 == 0 ?
            <span className="chartViewReportsBtn btn singleReportAddContext"
                  onClick={()=>this.addReportResource('content', e)}>
                  <span className="chartViewReportsBtnLabel">Add subsection
                    <img src={AddContent} className="singleReportAddContextImg"/>
                  </span>
                </span>
          :null }
          </span>)
      })}
    </div>)
  }

}

changePeriod = period => {
 
  if(period==1){
    this.props.createDashboardReport({period:'daily'})
  } else if(period==2){
    this.props.createDashboardReport({period:'monthly'})
  } else if(period==3){
    this.props.createDashboardReport({period:'yearly'})
  }
}




togglePeriod=()=>{
  this.setState(prevState=>({
    dropdownOpenPeriod: !prevState.dropdownOpenPeriod
  }))
}

renderUpdate=()=>{
  let{singleNote,actionType,description,dropdownOpenPeriod}=this.state
  return (
    <div className="singleInsightViewContainer"  
    // ref={(node) => { this.childNode1 = node; }} 
     >
                        <Title 
                        ref={this.childRef}
                        // ref={this.ChildElement} 
                        // changeReportTitle={this.changeReportTitle}
                        actionType={actionType}
                        isSection={true}
                        isFirstSection={true}
                        changeInsightAction={this.changeInsightAction}
                        singleNote ={singleNote}
                        // name = {this.state.singleNote && this.state.singleNote.name?this.state.singleNote.name:''}
                        openCreateChartReport={this.openCreateChartReport}
                        submitChartInsight={this.submitChartInsight} />

<Dropdown  isOpen={dropdownOpenPeriod} toggle={this.togglePeriod} className="dbPlotSizeDropdown singleReportPeriodDropdown">
              <DropdownToggle caret  className="dashboardChartSizeBtn singleReportPeriodBtn">
              {this.props.reports.temp && this.props.reports.temp.period?
              `Report ${this.props.reports.temp.period}`
              :"Select report time period"}
              </DropdownToggle>
              <DropdownMenu className="singleTaskViewMenu">
                {/* <DropdownItem header>Change chart size</DropdownItem> */}
                  <DropdownItem className="chartBtnView singleReportPeriodDdTxt"  onClick={()=>this.changePeriod(1)}>Report daily</DropdownItem>
                  <DropdownItem className="chartBtnView singleReportPeriodDdTxt"  onClick={()=>this.changePeriod(2)}>Report monthly</DropdownItem>
                  <DropdownItem className="chartBtnView singleReportPeriodDdTxt"  onClick={()=>this.changePeriod(3)}>Report yearly</DropdownItem>
              </DropdownMenu>
            </Dropdown>

  
                      {/* <div  className="singleReportAddDescriptionContent" >
                          <CKEditorUI
                            onChange={this.handleChangeText}
                            value={description}
                            afterPaste={this.addText}
                          />
                      </div> */}

                      {/* <ReportUploads /> */}

                { this.renderSections()}

                      
              

                <span className="chartViewReportsBtn btn btn-info addSectionBtn"
                  onClick={()=>this.addReportResource('section')}>
                  <span className="chartViewReportsBtnLabel">Add section
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                  </span>
                </span>

    </div>
  )
}





renderView=()=>{
  let{ actionType}=this.state
  if(actionType=='VIEW'){
    return this.renderViewOnly()
  }  else {
   
    return this.renderUpdate()
  }
}









  render() { 
    // let{updatedFields, singleNote, setImagesPreview,openCreateChartReport,rejectedFiles}=this.state
    // let total_uploads = setImagesPreview.concat(rejectedFiles)
   let{openCreateChartReport}=this.state
    return  openCreateChartReport?this.renderView():null
 
    
  }
}




const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports

  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReportCharts:(dashboard)=> dispatch(actionCreators.updateReportCharts(dashboard)),
    createDashboardReport:(dashboard)=> dispatch(actionCreators.createDashboardReport(dashboard)),

  }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(SingleReport, axios)));



